import api from ".";

export const deleteEquipment = async (id: number) => {
  const token = localStorage.getItem("uniservice_token");
  const url = `/api/v1/equipment/${id}`;

  try {
    const response = await api.delete(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response;
  } catch (error) {
    console.error(
      "Erro ao excluir equipamento. Por favor, tente novamente",
      error,
    );
    throw error;
  }
};
